export default __webpack_public_path__ + "static/media/phone.b9ad7ce4.svg";